import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import constants from '../../qti/Constants';
import AdditionalResource from './AdditionalResource';
import storeManager from '../../store/StoreManager';
import uiActions from '../../actions/UIActions';
import apiService from '../../services/api/ApiService';
import sessionReader from '../../store/readHelpers/SessionReader';

class PciAdditionalResource extends React.PureComponent {
    static propTypes = {
        resource: PropTypes.object.isRequired,
        overlayOpen: PropTypes.bool.isRequired,
        minimized: PropTypes.bool.isRequired,
    };

    minimizeOtherOverlays(excludeId) {
        const overlays = storeManager.getState()?.ui?.pciResourceOverlays || {};
        Object.keys(overlays).forEach((id) => {
            const numId = Number(id);
            if (numId !== excludeId && !overlays[id].minimized) {
                storeManager.dispatch(uiActions.uiSetPciResourceMinimized(numId, true));
            }
        });
    }

    handleClick = async (e) => {
        if (e) {
            e.preventDefault();
        }

        if (this.isHandlingClick) {
            return;
        }
        this.isHandlingClick = true;

        await this.processClick().finally(() => {
            this.isHandlingClick = false;
        });
    };

    processClick = async () => {
        const { resource, overlayOpen, minimized } = this.props;

        if (overlayOpen && !minimized) {
            return;
        }

        this.minimizeOtherOverlays(resource.contentItemId);

        if (overlayOpen) {
            storeManager.dispatch(uiActions.uiSetPciResourceMinimized(resource.contentItemId, false));
            return;
        }

        storeManager.dispatch(uiActions.uiOpenPciResourceOverlay(resource));

        try {
            const payload = {
                assessmentRunId: sessionReader.getAssessmentRunId(),
                resourceContentItemId: resource.contentItemId,
                resourceContentRevisionId: resource.contentRevisionId === undefined ? null : resource.contentRevisionId,
            };
            const runtime = await apiService.getPciResourceRuntime(payload);

            if (runtime && runtime.success) {
                storeManager.dispatch(uiActions.uiSetPciResourceRuntime(resource.contentItemId, runtime));
            } else {
                storeManager.dispatch(uiActions.uiSetPciResourceError(resource.contentItemId, runtime?.message));
            }
        } catch (err) {
            storeManager.dispatch(uiActions.uiSetPciResourceError(resource.contentItemId, 'pci-resource-runtime-error'));
        }
    };

    render() {
        const { resource } = this.props;

        return (
            <AdditionalResource
                url=""
                title={resource.title}
                type={constants.additionalResourceType.PCI_TOOL}
                onClick={this.handleClick}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const overlay = state.ui?.pciResourceOverlays?.[ownProps.resource.contentItemId];
    return {
        overlayOpen: !!overlay && !overlay.error,
        minimized: !!overlay?.minimized,
    };
};

export { PciAdditionalResource as PciAdditionalResourceUnconnected };
export default connect(mapStateToProps)(PciAdditionalResource);
